<template>
  <b-card title="Segurança🙌">
    <b-card-text>This is your second page.</b-card-text>
   
  </b-card>
</template>

<script>
import { BCard, BCardText } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
  },
}
</script>

<style>

</style>
